//PoS MALWARE VARIANTS
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE 
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../../components/heading'
import Navbar from '../../../components/navbar'
import Footer from '../../../components/footer'
import FullWidthImage from '../../../components/FullWidthImage'
import PageHeader from '../../../components/PageHeader'
import TextBlock from '../../../components/textblock'
import Header from '../../../components/Header'
import AlphabetShortcuts from '../../../components/AlphabetShortcuts'
import BodySection from '../../../components/BodySection'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************  
const posMalwarePage = ({data}) => {
    
    const posMalware = data.pos_malware_variants.edges
    
    return (        
        
        <div>
        
            
             <Helmet>
                   <title>NJCCIC Point of Sale Malware Variants</title>
                    <meta name="description" content="The NJCCIC collections of threat profiles on point of sale malware"/>
                </Helmet>
            <Heading/>
            
            <Navbar/>
        
            {posMalware.map(({ node: {malware_type, introductory_text, content_group, content_group_a, content_group_b, content_group_c, content_group_d, content_group_f, content_group_g, content_group_l, content_group_m, content_group_n, content_group_p, content_group_r, content_group_s, content_group_t, content_group_u, headers, image} }) => (
        
               <div>
        
                    <PageHeader elementClass="pageHeader centerText" title={malware_type}/>
        
                    <div class="container containerWidth">
        
                        <div class="row">
        
                            <TextBlock elementClass="col-12standardText introPadding alertsIntro" text={introductory_text}/>
                            
                        </div>
        
                    </div>
        
                    <AlphabetShortcuts testClass="testClass container containerWidth alphabet" elementClass="letterShortcuts" data={content_group}/>
        
                    <FullWidthImage id="malwareBanner" src={image}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[0].section_name} id="a"/>
        
                    <BodySection data={content_group_a}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[1].section_name} id="b"/>
        
                    <BodySection data={content_group_b}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[2].section_name} id="c"/>
        
                    <BodySection data={content_group_c}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[3].section_name} id="d"/>
        
                    <BodySection data={content_group_d}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[4].section_name} id="f"/>
        
                    <BodySection data={content_group_f}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[5].section_name} id="g"/>
        
                    <BodySection data={content_group_g}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[6].section_name} id="l"/>
        
                    <BodySection data={content_group_l}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[7].section_name} id="m"/>
        
                    <BodySection data={content_group_m}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[8].section_name} id="n"/>
        
                    <BodySection data={content_group_n}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[9].section_name} id="p"/>
        
                    <BodySection data={content_group_p}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[10].section_name} id="r"/>
        
                    <BodySection data={content_group_r}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[11].section_name} id="s"/>
        
                    <BodySection data={content_group_s}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[12].section_name} id="t"/>
        
                    <BodySection data={content_group_t}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[13].section_name} id="u"/>
        
                    <BodySection data={content_group_u}/>
        
                </div>  
        
            ))}                 
        
            <Footer/>
            
        </div>

    )    
    
}
//*******************************************************************
//*******************************************************************  
export const query = graphql`
    query {
        pos_malware_variants: allButterPage(filter: {slug: { eq: "pos-malware-variants" } }) {
            edges {
                node {
                    malware_type
                    introductory_text
                    content_group_a {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_b {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_c {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_d {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_f {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_g {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_l {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_m {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_n {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_p {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_r {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_s {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_t {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    content_group_u {
                        seo_title
                        section_name
                        preview_text
                        toggle_target
                        main_text
                        icon
                    }
                    image
                    headers {
                        section_name
                    }
                    content_group {
                        text
                    }
                }
            }
        }
    }
`
export default posMalwarePage
//*******************************************************************
//*******************************************************************